import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { AccountService } from '../proxy/controlling/controllers/account.service';
import { OldAccountService } from '../proxy/controlling/controllers/old-account.service';
import { SapMaterialService } from '../proxy/controlling/controllers/sap-material.service';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';
FieldBuilder.setNamespace('Controlling');

export const SAPRELATIONSAPACCOUNTOLDACCOUNT_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('accountId', 'Entity.Account', AccountService)
    .displayFromNested('account.name')
    .sortBy('account.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('oldAccountId', 'Entity.OldAccount', OldAccountService)
    .required()
    .displayFromNested('oldAccount.description')
    .sortBy('oldAccount.description')
    .build(),
  FieldBuilder.foreignKey('sapMaterialId', 'Entity.SapMaterial', SapMaterialService)
    .displayFromNested('sapMaterial.description')
    .sortBy('sapMaterial.description')
    .build(),
  FieldBuilder.foreignKey('companyCodeId', 'Entity.CompanyCode', CompanyCodeService)
    .displayFromNested('companyCode.name')
    .sortBy('companyCode.name')
    .build(),
];

export const SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG = {
  entityName: 'SapRelationSapAccountOldAccount',
  localizationKey: 'Controlling::Entity.SapRelationSapAccountOldAccount',
  fields: SAPRELATIONSAPACCOUNTOLDACCOUNT_FIELDS,
  permission: 'ControllingSap.SapRelationSapAccountOldAccounts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
